/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fetchJson } from '@atlassian/jira-fetch/src/index.tsx';

import type { IncidentSuggestion } from './IncidentSuggestion.types.tsx';
import type { IncidentSuggestionRequestParams } from './ServerRawResponseV2.types.tsx';
import { transformResponseV2 } from './transformResponseV2.tsx';

export const getIncidentSuggestionUrl = ({
	cloudId,
	issueId,
	projectId,
	locale,
}: IncidentSuggestionRequestParams): string =>
	`/gateway/api/jsm/aiops/cloudId/${cloudId}/api/v1/incident-suggestion/${issueId}?projectId=${projectId}&locale=${locale}
`;

export const getIncidentSuggestionEndpoint = (
	reqParams: IncidentSuggestionRequestParams,
): Promise<IncidentSuggestion> => {
	const url = getIncidentSuggestionUrl(reqParams);
	return fetchJson(url, {
		method: 'GET',
	}).then(transformResponseV2);
};
